var ImageFit = /* @__PURE__ */ ((ImageFit2) => {
  ImageFit2["COVER"] = "cover";
  ImageFit2["CONTAIN"] = "contain";
  return ImageFit2;
})(ImageFit || {});
var ImageAlignment = /* @__PURE__ */ ((ImageAlignment2) => {
  ImageAlignment2["LEFT"] = "left";
  ImageAlignment2["CENTER"] = "center";
  ImageAlignment2["RIGHT"] = "right";
  return ImageAlignment2;
})(ImageAlignment || {});
var ImagePosition = /* @__PURE__ */ ((ImagePosition2) => {
  ImagePosition2["TOP"] = "top";
  ImagePosition2["BOTTOM"] = "bottom";
  return ImagePosition2;
})(ImagePosition || {});
export {
  ImageAlignment,
  ImageFit,
  ImagePosition
};
//# sourceMappingURL=image.js.map
